import { supabaseClient } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";
import { validate as validateUUID } from "uuid";

export const createRegulatedModeKey = (diaryId: string | null | undefined) => ["regulated-mode", diaryId] as const;

/**
 * Resolve whether a diary uses ALCOA+ regulated capture.
 *
 * The effective value is the diary override, else the organisation flag, else false.
 * Computed server-side by the `is_diary_regulated` SQL function so the rule stays in
 * one place and cannot be spoofed by the client.
 */
export const useRegulatedMode = (diaryId: string | null | undefined) => {
    const query = useQuery({
        queryKey: createRegulatedModeKey(diaryId),
        queryFn: async () => {
            const { data, error } = await supabaseClient.rpc("is_diary_regulated", {
                p_diary_id: diaryId!,
            });
            if (error) throw error;
            return Boolean(data);
        },
        enabled: Boolean(diaryId) && validateUUID(diaryId ?? ""),
        staleTime: 1000 * 60 * 5,
    });

    return {
        isRegulated: query.data ?? false,
        isLoading: query.isLoading,
    };
};
